import React from 'react'
import CenterModal from '../../../components/Modals/center-modal'
import SmallCenterModal from '../../../components/Modals/small-center-modal'
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as BookingIcon } from '../../../assets/icons/booking.svg';
import { ReactComponent as TokenExpireIcon } from '../../../assets/plus_icon/token_expire.svg'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as PendingIcon } from '../../../assets/plus_icon/incentive_pending.svg';
import { ReactComponent as PaidIcon } from '../../../assets/plus_icon/incentive_paid.svg';
import { ReactComponent as CallingIcon } from '../../../assets/icons/calling.svg'
import { ReactComponent as RightIcon } from '../../../assets/icons/righticon_primary.svg'

const BookingCancelDetailModal = ({ show, closeModal, selectedLead, setSelectedTimelineLead, setShowTimeline }) => {
    return (
        <SmallCenterModal show={show} closeModal={closeModal} modalClass='w-[400px]'>
            <div className='!p-6'>
                <div className='flex items-center justify-between !mb-4'>
                    <div className='h-12 w-12 rounded-xl bg-[#FF974A] flex items-center justify-center'>
                        <BookingIcon className='fill-white h-6 w-6' />
                    </div>
                    <button className='border-0 bg-tr ' onClick={closeModal}><CloseIcon /></button>
                </div>
                <h3 className='text-lg font-semibold'>Booking Details</h3>
                <div className='border rounded-xl !py-2 !px-4'>
                    <div className='flex justify-between items-center text-sm !mt-3' >
                        <span className='text-black700'>Project</span>
                        <span>Coastal Living Realty</span>
                    </div>
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-between items-center text-sm'>
                        <span className='text-black700'>Booking Date&Time</span>
                        <span>4:00 pm, 6th Sep 24</span>
                    </div>
                    <div className='border-t !my-4'></div>

                    <div className='flex justify-between items-center text-sm'>
                        <span className='text-black700'>Tagging validity</span>
                        <span className='text-xs text-red bg-[#FF974A1A]/10 !py-1 px-2.5 font-bold rounded-2xl'>
                            Tagging Cancelled
                        </span>
                    </div>
                    <div className='border-t !my-4'></div>


                    <div className='flex justify-between items-center text-sm'>
                        <span className='text-black700'>unit</span>
                        <span className=''>

                            3 Bhk 988 sq.ft.
                        </span>
                    </div>
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-between items-center text-sm !mb-4'>
                        <span className='text-black700'>Net Purchase Price</span>
                        <span className=''>
                            ₹ 10,000
                        </span>
                    </div>
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-between items-center text-sm !mb-4'>
                        <span className='text-black700'>Brokerage</span>
                        <span className=''>
                            ₹ 10,000
                        </span>
                    </div>
                    {/* <div className='border-t !my-4'></div> */}
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-center items-center'>
                        <button className='text-blue-900 font-semibold text-xs flex items-center' onClick={() => {
                            setSelectedTimelineLead(selectedLead);
                            setShowTimeline(true);
                            closeModal();
                        }}>
                            Show SV Timeline
                            <RightIcon className='fill-primary' />
                        </button>
                    </div>
                </div>
                <div className=' !mt-8'>
                    <button className='w-full border rounded-xl py-2.5 flex items-center justify-center'>
                        {/* <span>
                            <CallingIcon />
                        </span> */}
                        Call your SM
                    </button>

                </div>
            </div>
        </SmallCenterModal>
    )
}

export default BookingCancelDetailModal